<template>
  <AuthCard>
    <div class="text-center">
      <div class="result-icon" :class="{ success: !error, fail: error }">
        <svg v-if="!error" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="20 6 9 17 4 12"/>
        </svg>
        <svg v-else viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round">
          <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
        </svg>
      </div>
      <h3>{{ error ? 'Confirmation failed' : 'Email confirmed!' }}</h3>
      <p class="sub">{{ error || 'Your account is ready. Redirecting to sign in…' }}</p>
      <router-link v-if="error" to="/signin" class="btn-link">Go to sign in</router-link>
    </div>
  </AuthCard>
</template>

<script>
  import AuthCard from '../common/AuthCard.vue'
  import { sleep } from '@/utils'

  export default {
    name: 'ConfirmRegistration',
    components: { AuthCard },
    data: () => ({ error: '' }),
    async mounted() {
      const token = this.$route.params.token
      if (token) {
        try {
          await this.$store.dispatch('confirmRegistration', token)
          await sleep(1500)
          this.$router.push({ name: 'signIn', query: { focusEmail: '1' } })
        } catch (e) {
          this.error = e?.response?.data?.message || e?.message || 'Invalid or expired token. Please try again.'
        }
      } else {
        this.error = 'No token provided.'
      }
    }
  }
</script>

<style scoped>
.result-icon {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 1rem;
}

.result-icon svg { width: 22px; height: 22px; }

.result-icon.success { background: rgba(123, 175, 150, 0.15); color: #3a7a5a; }
.result-icon.fail    { background: rgba(220, 80, 80, 0.12);  color: #c0392b; }

h3 { margin-bottom: 0.4rem; }

.sub {
  font-size: 0.85rem;
  color: #777;
  line-height: 1.5;
}

.btn-link {
  display: inline-block;
  margin-top: 1rem;
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--primary, #5B8DB8);
  text-decoration: none;
}

.btn-link:hover { text-decoration: underline; }
</style>
